<template>
<div id="login">
    <v-container>
        <v-row justify="center">
            <v-col md="5">
                <div>
                    <h1>Login</h1>
                    <v-form @submit.prevent="authenticate">
                        <v-text-field v-model="username" label="Username" type="text" autocomplete="current-login" :rules="[rules.required]"></v-text-field>
                        <v-text-field v-model="password" label="Password" type="password" autocomplete="current-password" :rules="[rules.required]"></v-text-field>

                        <v-alert color="red darken-4" v-show="shouldShowError">Provided credentials do not match.</v-alert>

                        <v-btn type="submit">Log in</v-btn>
                    </v-form>
                </div>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script>
export default {
    data: () => ({
        username: "",
        password: "",
        shouldShowError: false,
        rules: {
            required: (value) => !!value || "Required"
        }
    }),
    computed: {
        form() {
            return {
                username: this.username,
                password: this.password
            }
        }
    },
    watch: {
        username() {
            this.shouldShowError = false
        },
        password() {
            this.shouldShowError = false
        }
    },
    methods: {
        authenticate() {
            if (!this.username) return;
            if (!this.password) return;
            this.$store.dispatch("auth/login", this.form)
                .then(() => {
                    this.$router.push({
                        name: "home"
                    })
                })
                .catch((error) => {
                    if (error.response.status !== 422) return;
                    this.shouldShowError = true
                })
        }
    }
}
</script>
